import React from 'react';
import { Link } from 'react-router-dom';
import BrushOutlinedIcon from '@mui/icons-material/BrushOutlined';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import { Reveal, RevealGroup, RevealItem } from '../../components/Reveal';
import MagneticButton from '../../components/MagneticButton';
import '../css/ProductCategories.css';

const ProductCategories = () => {
  const categories = [
    { id: 1, icon: <BrushOutlinedIcon />, name: 'Paint Application Tools', description: 'Professional brushes, rollers, pads, and spray equipment engineered for perfect, even finishes on any surface.', image: '/images/categories/category-1.png', productCount: 48 },
    { id: 2, icon: <BuildOutlinedIcon />, name: 'Surface Preparation Tools', description: 'Scrapers, putty knives, and trowels for thorough surface prep — the foundation of every quality paint job.', image: '/images/categories/category-2.png', productCount: 35 },
    { id: 3, icon: <SettingsOutlinedIcon />, name: 'Sanding & Polishing Tools', description: 'High-quality sanding sponges, steel wool, and abrasive screens for smooth, flawless surfaces.', image: '/images/categories/category-3.png', productCount: 29 },
    { id: 4, icon: <Inventory2OutlinedIcon />, name: 'Accessories & Assortments', description: 'Paint trays, liners, grids, extension poles, drop cloths, and complete ready-to-sell assortment kits.', image: '/images/categories/category-4.png', productCount: 62 },
    { id: 5, icon: <CategoryOutlinedIcon />, name: 'Specialty & Industrial', description: 'Heavy-duty tools for industrial applications, including masonry, facade, and large-scale coating projects.', image: '/images/categories/category-5.png', productCount: 22 },
    { id: 6, icon: <BrushOutlinedIcon />, name: 'Export Assortment Packs', description: 'Pre-designed, export-ready assortment packs ideal for retail displays and bulk distributor orders.', image: '/images/categories/category-6.png', productCount: 18 },
  ];

  return (
    <div className="categories-page">

      <section className="cats-hero">
        <div className="container">
          <Reveal as="div" className="cats-hero-inner">
            <span className="eyebrow">Browse By Category</span>
            <h1>Product Categories</h1>
            <p>A complete ecosystem of professional painting tools — organized for easy sourcing and bulk ordering.</p>
          </Reveal>
        </div>
      </section>

      <section className="cats-body">
        <div className="container">
          <RevealGroup className="cats-grid">
            {categories.map(cat => (
              <RevealItem key={cat.id}>
                <Link to="/products" className="cat-card">
                  <div className="cat-img-wrap">
                    <img src={cat.image} alt={cat.name} />
                    <div className="cat-overlay">
                      <span>Browse Products <ArrowForwardIcon /></span>
                    </div>
                  </div>
                  <div className="cat-info">
                    <div className="cat-icon-wrap">{cat.icon}</div>
                    <div className="cat-text">
                      <h3>{cat.name}</h3>
                      <p>{cat.description}</p>
                    </div>
                    <span className="cat-count">{cat.productCount} Products</span>
                  </div>
                </Link>
              </RevealItem>
            ))}
          </RevealGroup>

          <Reveal as="div" className="cats-bottom-cta">
            <h2>Can't Find What You're Looking For?</h2>
            <p>We also offer custom product development and private-label solutions for large orders.</p>
            <div className="cats-cta-actions">
              <MagneticButton to="/contact" className="btn-primary">Contact Our Team</MagneticButton>
              <Link to="/products" className="btn-ghost">View All Products</Link>
            </div>
          </Reveal>
        </div>
      </section>

    </div>
  );
};

export default ProductCategories;
